import React from 'react';
import { App } from '@metapackltd/dt-components';

export default function AppWrapper(props) {
  return <App {...props} />;
}
